import { render, staticRenderFns } from "./ConsignmentInstructionsModal.vue?vue&type=template&id=427bf03a&scoped=true&lang=pug"
import script from "./ConsignmentInstructionsModal.vue?vue&type=script&lang=js"
export * from "./ConsignmentInstructionsModal.vue?vue&type=script&lang=js"
import style0 from "./ConsignmentInstructionsModal.vue?vue&type=style&index=0&id=427bf03a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427bf03a",
  null
  
)

export default component.exports